<template>
  <div class="container">
    <router-view :key="$route.fullPath"></router-view>
    <MobileNavbar v-if="ifPrivate" :key="$route.fullPath"/>
  </div>
</template>

<script>
import MobileNavbar from '@/components/Mobile/Navbar.vue'

export default {
  components: {
    MobileNavbar
  },
  computed: {
    ifPrivate() {
      if (
          this.$route.name != undefined &&
          !this.$route.name.startsWith("public-") &&
          !this.$route.name.startsWith("questionnaire") &&
          this.$route.name != ("question")
      ) {
        return true
      }
      return false
    }
  },
  data() {
    return {
      message: 'false'
    }
  },
};
</script>